export default __webpack_public_path__ + "static/media/oops.782500e1.gif";